import LookupController from "./lookup_controller";

export default class extends LookupController {
}